import { render, staticRenderFns } from "./docsLayout.vue?vue&type=template&id=529fb030&scoped=true&"
import script from "./docsLayout.vue?vue&type=script&lang=ts&"
export * from "./docsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./docsLayout.vue?vue&type=style&index=0&id=529fb030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529fb030",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrackingNoscript: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/_trackingNoscript.vue').default,HomepageHeader: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageHeader.vue').default,PageFooter: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/page/PageFooter.vue').default})
